(function () {
  'use strict';

  function init(root) {
    var comparison = root.matches && root.matches('compare-reference') ? root : root.querySelector('compare-reference');
    if (!comparison || comparison.dataset.referenceBound === '1') return;
    comparison.dataset.referenceBound = '1';

    var buttons = Array.prototype.slice.call(comparison.querySelectorAll('[data-compare-view]'));
    var panels = Array.prototype.slice.call(comparison.querySelectorAll('[data-compare-panel]'));
    var routerAnchor = comparison.querySelector('[data-router-anchor]');
    var sticky = comparison.querySelector('[data-sticky-cta]');
    var expanded = false;

    function setExpanded(value) {
      expanded = value;
      panels.forEach(function (panel) {
        panel.querySelectorAll('.ry-compare-ref__row.is-extra').forEach(function (row) {
          row.hidden = !expanded;
        });
        var more = panel.querySelector('[data-expand-rows]');
        if (more) {
          more.setAttribute('aria-expanded', String(expanded));
          more.textContent = expanded ? 'Show fewer rows −' : 'Show all ' + more.dataset.total + ' rows +';
        }
      });
    }

    function scrollToRouter() {
      var headerGroup = document.querySelector('#header-group');
      var headerHeight = headerGroup ? headerGroup.offsetHeight : 0;
      var compareHeader = comparison.querySelector('.ry-compare-ref__header');
      var y = routerAnchor.getBoundingClientRect().top + window.scrollY - headerHeight - compareHeader.offsetHeight;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }

    function select(view, shouldScroll) {
      buttons.forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.compareView === view));
      });
      panels.forEach(function (panel) {
        panel.hidden = panel.dataset.comparePanel !== view;
      });
      if (history.replaceState) history.replaceState(null, '', '#' + (view === 'supplements' ? 'vs-supplements' : 'vs-grains'));
      if (shouldScroll) requestAnimationFrame(scrollToRouter);
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () { select(button.dataset.compareView, true); });
    });
    comparison.querySelectorAll('[data-cross-link]').forEach(function (button) {
      button.addEventListener('click', function () { select(button.dataset.crossLink, true); });
    });
    comparison.querySelectorAll('[data-expand-rows]').forEach(function (button) {
      button.addEventListener('click', function () { setExpanded(!expanded); });
    });

    function updateSticky() {
      if (!sticky) return;
      var activePanel = comparison.querySelector('[data-compare-panel]:not([hidden])');
      var firstRow = activePanel && activePanel.querySelector('.ry-compare-ref__row');
      var show = firstRow && firstRow.getBoundingClientRect().top < window.innerHeight * .58;
      sticky.classList.toggle('is-visible', !!show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky, { passive: true });
    setExpanded(false);
    select(window.location.hash === '#vs-supplements' ? 'supplements' : 'grains', false);
    updateSticky();
  }

  function initAll(scope) {
    if (scope.matches && scope.matches('compare-reference')) init(scope);
    scope.querySelectorAll('compare-reference').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
